<template>
  <section class="main-slider container cl-white">
    <no-ssr>
      <carousel :per-page="1"
        :pagination-enabled="true"
        :autoplay-hover-pause="true"
        :autoplay-timeout="5000"
        :speed="1000"
        :autoplay="true"
        :loop="true"
        pagination-active-color="#f26190"
        pagination-color="#ffffff"
        v-if="showCarousel"
      >
        <slide v-for="(slide, index) in slides" :key="index">
          <a class="container w-100 item" :href="slide.link" v-lazy:background-image="getImagePath(slide)" />
        </slide>
      </carousel>
    </no-ssr>
  </section>
</template>

<script>
import config from 'config';
import NoSSR from 'vue-no-ssr'
import RootCateogry from 'theme/mixins/rootCategory';
import ButtonOutline from 'theme/components/theme/ButtonOutline'

export default {
  data () {
    return {
      showCarousel: false,
      currentSlide: 1,
      slides: [],
      totalSlides: 1,
      autoplayTimeout: 5000,
      speed: 1000,
    }
  },
  mixins: [RootCateogry],
  props: {
    cmsBannerSectionId: {
      type: String,
      required: false,
      default: 'bs_LOGIN_TOP_BANNER'
    }
  },
  components: {
    ButtonOutline,
    'Carousel': () => import(/* webpackChunkName: "vue-carousel" */ 'vue-carousel').then(Slider => Slider.Carousel),
    'Slide': () => import(/* webpackChunkName: "vue-carousel" */ 'vue-carousel').then(Slider => Slider.Slide),
    'no-ssr': NoSSR
  },
  computed: {
    bannerData () {
      let __response = this.$store.getters[`cmsBlock/cmsBlockIdentifier`](
        this.cmsBannerSectionId
      );
      if (__response) {
        return JSON.parse(__response.content);
      }
      return [];
    }
  },
  methods: {
    getImagePath (slide) {
      const { image, imageRelative } = slide;
      // const { url } = config.cmsB2B.banners;
      // if (imageRelative) {
      //   return `${url}${imageRelative}`;
      // }
      return image;
    },
    updateSliderData () {
      this.slides = this.getBanners();
      // this.slides = data.slides
      // this.totalSlides = data.total
    },
    sortSlideItems (a, b) {
      const aDate = a['updatedAt'] || a['creation_time']
      const bDate = b['updatedAt'] || b['creation_time']

      if (aDate > bDate) {
        return -1
      }
      if (aDate < bDate) {
        return 1
      }
      return 0
    },
    getBanners () {
      if (this.bannerData === null) {
        return [];
      }
      if (typeof this.bannerData.items === 'undefined') {
        return [];
      }
      let _items = this.bannerData.items.filter(e => {
        if (this.getRootCategorySlug === null) {
          // dla strony glownej
          if (typeof e.categorySlug === 'undefined') {
            return true;
          }
          return false;
        } else {
          // dla stron kategorii
          if (typeof e.categorySlug === 'undefined') {
            return true;
          } else if (e.categorySlug === this.getRootCategorySlug) {
            return true;
          }
          return false;
        }
      });
      // console.log(_items);
      return _items.sort(this.sortSlideItems);
      // if (typeof this.bannerData.items !== 'undefined') {
      //   return this.bannerData.items;
      // }
      // return [];
    }
  },
  async mounted () {
    await this.$store.dispatch('cmsBlock/single', {
      key: 'identifier',
      value: this.cmsBannerSectionId
    });
    this.updateSliderData();
    setInterval(() => {
      this.currentSlide = (this.currentSlide + 1) % this.totalSlides;
    }, 5000);
    this.showCarousel = true;
    // setInterval(() => {
    //   this.currentSlide = (this.currentSlide + 1) % (this.totalSlides)
    // }, 5000)
  },
  created () {
    // this.updateSliderData(sliderData)
  }
}
</script>
<style lang="scss">
@import '~theme/css/variables/colors';
@import '~theme/css/helpers/functions/color';
$color-white: color(white);
.main-slider {

  .VueCarousel-wrapper {
    border-radius: 30px;

    .VueCarousel-inner {
      .VueCarousel-slide {
        .item {
          height: auto;
          //282px;
          padding-bottom: 14.8%;
          display: block;
          background-position: bottom;
          background-repeat: no-repeat;
          background-size: cover;
          border-radius: 30px;
          // @media (max-width: 768px) {
          //   height: 200px;
          //   background-size: cover;
          //   background-repeat: no-repeat;
          // }

          &:hover::after {
            background-color: transparent !important;
          }
        }
      }
    }
  }

  .VueCarousel-dot {
    padding: 0 !important;
    margin: 20px 10px 0;
  }

  .VueCarousel-dot--active {
    &:focus {
      outline: none !important;
      border: none;
    }
  }

  @media (max-width: 767px) {
    display: none;
  }

  .VueCarousel-pagination {
    position: absolute;
    bottom: 15px;
  }
  .VueCarousel-dot--active .VueCarousel-dot-inner {
    border: 2px solid $color-white;
    margin-top: -2px;
  }
}
</style>
<style scoped>
h1 {
  font-size: 72px;
}
.main-slider {
  max-height: 640px;
}
.container {
  background-size: cover;
  background-position: center;
  background-repeat: no-repeat;
}
.row {
  height: 640px;
}
@media (max-width: 75em) {
  /* .main-slider {
    height: 400px;
  } */
  .title {
    font-size: 50px;
  }
  .subtitle {
    font-size: 20px;
  }
  .row {
    height: 400px;
  }
}
@media (max-width: 64em) {
  /* .main-slider {
    height: 359px;
  } */
  .container {
    background-position: left;
  }
  .title {
    font-size: 48px;
  }
  .subtitle {
    font-size: 18px;
  }
  .button {
    font-size: 16px;
  }
  .row {
    height: 359px;
  }
}
</style>
